import getFirebaseAuth from 'actions/firebase/auth'
import { sendPasswordResetEmail } from 'firebase/auth'

const forgetPassword = async (email) => sendPasswordResetEmail(getFirebaseAuth(), email)

export default forgetPassword
